const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://vydrzzfhae.execute-api.us-west-2.amazonaws.com/prod',
    TARGET_API_URL: 'https://5zahvlwdw9.execute-api.us-west-2.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.staging.pas.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.12.2',
    HOSTNAME: 'https://targets.staging.pas.forwoodsafety.com'
  }
};

export default config;